angular.module('jv.Dashboard.My.Pending.Evaluations.Controller', [])
.controller('jv.Dashboard.My.Pending.Evaluations.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs','$rootScope', 'TemplateLoader','jvDashboardFactory','jvHireUrlService',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, TemplateLoader,jvDashboardFactory, jvHireUrlService){
        jvContextualLoadingService.hide($scope.widgetObject.widgetId);

        $scope.pageSize = 5;
        $scope.totalCount = 0;
        $scope.currentPage = 0;

        $scope.submit = function(evaluation) {
            $window.location = jvHireUrlService.getApplicationDetailsUrlWithTab(evaluation.applicationEId,{},'evaluations-submit/{0}/{1}/{2}'.format(evaluation.applicationEId,evaluation.candidateStateEId,evaluation.interviewPkEId));
        };

        $scope.getMyPendingEvaluations = function(pageNumber) {
            var widgetSettings = $scope.widgetObject.userWidgetSettings.widgetSetting;
            angular.forEach(widgetSettings, function(widgetSetting, index){
                var settingObject;
                if (widgetSetting.userValues) {
                    settingObject = widgetSetting.userValues[0];
                } else {
                    if(widgetSetting.settings.defaultValues){
                        settingObject = widgetSetting.settings.defaultValues[0];
                    }
                }
                switch(widgetSetting.settings.name) {
                    case "Duration":
                        $scope.duration = settingObject.value;
                    break;
                    default:
                    break;
                }
            });
            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            $scope.currentPage = pageNumber;
            var args = {
                page: $scope.currentPage,
                pageSize: $scope.pageSize,
                days: $scope.duration
            };
            /*
            Making sure we send refresh true for new widget creating flow
            Cannot set refresh true in the REFRESH_WIDGET emit callback since the controller gets re-initialized for a newly added widget.
            Hence storing this in the factory 
            */
            //send refresh=true to get data from DB
            if($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject)) {
                args.refresh = true;
            }
            jvDashboardAjaxService.getMyPendingEvaluations(args, function(response) {
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                if (response && response.evaluationInfo) {
                    $scope.lastUpdated = response.lastUpdated;
                    $scope.evaluations = response.evaluationInfo;
                    $scope.totalCount = response.count;
                } else {
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        };

        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                //invalidate cache and fetch data from DB 
                $scope.lastUpdated = '';
                $scope.refresh = true;
                $scope.getMyPendingEvaluations(0);
            }
        });
        $scope.getMyPendingEvaluations(0);
}]);